import React from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface Props {
	value: number;
	showLarge?: boolean;
}

const MatchPercentileCircularBar = ({ value, showLarge }: Props) => {
	return (
		<div className=" @3xl/profile-introduction:max-w-[100px] @3xl/profile-introduction:max-h-[56px] @4xl/profile-introduction:max-w-[120px] @4xl/profile-introduction:max-h-[56px]">
			<div className="flex flex-col items-center text-center ml-12 gap-1">
				<div className="max-w-[65px] max-h-[65px]">
					<CircularProgressbarWithChildren
						styles={buildStyles({
							pathColor:
								value >= 800
									? '#39D98A'
									: value >= 500 && value < 800
									  ? '#39D98A'
									  : value >= 300 && value < 500
									    ? '#F80'
									    : '#FF5C5C',
							trailColor: '#555770',
							strokeLinecap: 'round',
							pathTransitionDuration: 1,
							rotation: 0.75,
						})}
						strokeWidth={showLarge ? 13 : 11}
						maxValue={1000}
						circleRatio={0.5}
						value={value}
					>
						<div className="w-full h-full relative p-3 text-center">
							<div className="flex items-center justify-center">
								<p className="text-md mt-2 @3xl/profile-introduction:text-lg @4xl/profile-introduction:text-xl font-size-[16px] font-inter font-[700]">
									{Math.round((value / 1000) * 100)}%
								</p>
							</div>
						</div>
					</CircularProgressbarWithChildren>
				</div>
				<p className="text-[#8F90A6] text-[12px] -mt-7 font-[500] font-inter">
					{value >= 800
						? 'Excellent'
						: value >= 500 && value < 800
						  ? 'Good'
						  : value >= 300 && value < 500
						    ? 'Moderate'
						    : 'Low'}
				</p>
			</div>
		</div>
	);
};

export default MatchPercentileCircularBar;
